// client/src/components/wetakeover/VideoSection.jsx
import React, { useState } from 'react';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  // Replace with actual video URL
  const videoUrl = null; // e.g., 'https://www.youtube.com/embed/VIDEO_ID'
  const thumbnailUrl = null; // e.g., '/images/video-thumbnail.jpg'

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="py-16 md:py-20 max-w-6xl mx-auto px-4 relative">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-yellow-300/5 blur-[150px] rounded-full pointer-events-none" />

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            See How <span className="text-yellow-300">We Takeover</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Watch how our content amplification campaigns drive massive engagement for top Web3 brands
          </p>
        </div>

        {/* Video Container */}
        <div className="relative aspect-video rounded-[24px] md:rounded-[32px] overflow-hidden bg-white/5 border border-white/10 backdrop-blur-sm group mb-10">
          {isPlaying && videoUrl ? (
            <iframe
              src={`${videoUrl}?autoplay=1`}
              title="WeTakeover Campaign Video"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div
              className="w-full h-full flex items-center justify-center cursor-pointer"
              onClick={handlePlay}
            >
              {thumbnailUrl ? (
                <img
                  src={thumbnailUrl}
                  alt="Video thumbnail"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-300/5 via-transparent to-white/5" />
              )}

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <button
                  className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-yellow-300 hover:bg-yellow-400 motion-safe:hover:scale-105 transition-[background-color,transform] flex items-center justify-center shadow-[0_20px_60px_rgba(250,204,21,0.4)]"
                  aria-label="Play video"
                >
                  <svg
                    className="w-8 h-8 md:w-10 md:h-10 text-black ml-1"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Info Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-yellow-300/30 transition-colors text-center group">
            <div className="text-4xl font-bold text-yellow-300 mb-2 motion-safe:group-hover:scale-105 transition-transform">700+</div>
            <div className="text-white/60">Active KOLs</div>
          </div>
          <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-yellow-300/30 transition-colors text-center group">
            <div className="text-4xl font-bold text-yellow-300 mb-2 motion-safe:group-hover:scale-105 transition-transform">Info 2</div>
            <div className="text-white/60">Description</div>
          </div>
          <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-yellow-300/30 transition-colors text-center group">
            <div className="text-4xl font-bold text-yellow-300 mb-2 motion-safe:group-hover:scale-105 transition-transform">Info 3</div>
            <div className="text-white/60">Description</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
